/* eslint-disable jsx-a11y/label-has-associated-control, jsx-a11y/label-has-for */
import * as React from 'react';
import { List, Form } from 'semantic-ui-react';

// Global Components
// @ts-ignore
import SchemaName from 'components/SchemaName';
import RoleGate from 'components/RoleGate';
import { ADMIN } from 'components/RoleGate/constants';

// Child Components
// @ts-ignore
import SchemaToggle from './components/SchemaToggle';

interface Props {
    schemaId?: number;
}

export default class SchemasListItem extends React.PureComponent<Props> {
    render(): React.ReactElement | null {
        const { schemaId } = this.props;
        if (!schemaId) {
            return null;
        }
        return (
            <List.Item>
                <List.Content>
                    <Form>
                        <Form.Field inline>
                            <RoleGate requiredRoles={[ADMIN]}>
                                <SchemaToggle schemaId={schemaId} />
                            </RoleGate>
                            <label>
                                <SchemaName schemaId={schemaId} />
                            </label>
                        </Form.Field>
                    </Form>
                </List.Content>
            </List.Item>
        );
    }
}
